import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AppState } from 'features/app/store/app/interfaces/appState';

export const initialAppState: AppState = {
  isInnerLoading: false,
  isRnsConnectionSuccess: false,
  isUnloading: false,
  isRnsConnectionClosed: false,
  isTokenSetOnHeaders: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    setInnerLoading: (state, action: PayloadAction<boolean>) => {
      state.isInnerLoading = action.payload;
    },
    rnsAttemptingToReconnect: (state) => {
      state.isRnsConnectionSuccess = false;
    },
    rnsConnectionSuccess: (state) => {
      state.isRnsConnectionSuccess = true;
      state.isRnsConnectionClosed = false;
    },
    appUnloading: (state) => {
      state.isUnloading = true;
    },
    failedRnsConnection: (state) => {
      state.isRnsConnectionClosed = true;
      state.isRnsConnectionSuccess = false;
    },
    tokenSetOnHeaders: (state) => {
      state.isTokenSetOnHeaders = true;
    },
    tokenNotSetOnHeaders: (state) => {
      state.isTokenSetOnHeaders = false;
    },
  },
});

export const {
  setInnerLoading,
  rnsAttemptingToReconnect,
  rnsConnectionSuccess,
  appUnloading,
  failedRnsConnection,
  tokenSetOnHeaders,
  tokenNotSetOnHeaders,
} = appSlice.actions;

export default appSlice.reducer;
